import { Menu } from '@mui/material';
import { styled } from '@mui/styles';

export const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    {...props}
  />
))(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
  },
}));
